import React from 'react';
import PropTypes from 'prop-types';

import './SeeRepliesLink.scss';

const SeeRepliesLink = ({ url }) => {
    return (
        <div className="component-Community-CommentBox-SeeRepliesLinkContainer">
            <a
                className="component-Community-CommentBox-SeeRepliesLink"
                href={url}
            >
                See other replies
            </a>
        </div>
    );
};

SeeRepliesLink.propTypes = {
    url: PropTypes.string.isRequired,
};

SeeRepliesLink.defaultProps = {};

SeeRepliesLink.displayName = 'SeeRepliesLink';

export default SeeRepliesLink;
